module.exports = __webpack_public_path__ + "static/media/logo.d46e3f52.png";